export default "admin-page-header = Документы"